module.exports = __webpack_public_path__ + "img/social_media_embed.61677f8e.svg";